import { IWorkerProcess } from '../../ts/ServerApi/types/IWorkerProcess';
import { Request } from '../../ts/ServerApi/requests/Request';

export interface IGetServerInfoParams {
}

export interface IGetServerInfoResult {
  workerHosts: string[]; // First host in array is primary
  processes: IWorkerProcess[];
}

export class GetServerInfoRequest extends Request<IGetServerInfoParams, IGetServerInfoResult> {
  constructor(params: IGetServerInfoParams) {
    super('getServerInfo', params);
  }
}
